// ── Interview Prep (EX-FNC07) ──────────────────────────────────────────────
// The wire shape of `GET /v1/judge/interview`, docs/27 §9.46: the list the
// seeder wrote, by topic, with the signed-in reader's own state.

import type { ProblemDifficulty, SolvedState } from "../types";

export const INTERVIEW_TOPICS = [
  "array",
  "string",
  "hash-map",
  "two-pointers",
  "binary-search",
  "grid",
  "dp",
] as const;
export type InterviewTopic = (typeof INTERVIEW_TOPICS)[number];

export function isInterviewTopic(value: string | null | undefined): value is InterviewTopic {
  return (INTERVIEW_TOPICS as readonly string[]).includes(value ?? "");
}

export type InterviewPrepProblem = {
  id: string;
  slug: string;
  title_en: string;
  title_bn: string | null;
  topic: InterviewTopic;
  difficulty: ProblemDifficulty;
  tags: string[];
  /** `null` for an anonymous reader. */
  solvedState: SolvedState | null;
  solvers: number | null;
  attempters: number | null;
  submissions: number | null;
};

export type InterviewPrepTopicSummary = {
  key: InterviewTopic;
  total: number;
  /** `null` for an anonymous reader. */
  solved: number | null;
};

export type InterviewPrepViewer = {
  solved: number;
  attempted: number;
  /** First solved in practice in the last seven days. */
  solvedRecently: number;
};

export type InterviewPrepList = {
  topics: InterviewPrepTopicSummary[];
  problems: InterviewPrepProblem[];
  total: number;
  viewer: InterviewPrepViewer | null;
};
